import { render, staticRenderFns } from "./VehiclePageLeaseInclusions.vue?vue&type=template&id=58b9509c&"
import script from "./VehiclePageLeaseInclusions.vue?vue&type=script&lang=js&"
export * from "./VehiclePageLeaseInclusions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports